import React from "react";

import {
  Grid,
  TextControl,
  Form,
  Divider,
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@tiny/components";
import { CustomerInfoView } from "@tiny/api";
import { useUnsubscribeReasonDialog } from "./UnsubscribeReasonDialog.hooks";

export interface UnsubscribeReasonDialogProps {
  open: boolean;
  customer?: CustomerInfoView;
  onClose: () => void;
  onSuccess: () => void;
}

function UnsubscribeReasonDialog(props: UnsubscribeReasonDialogProps) {
  const { open, onClose, customer } = props;

  const { form, submitForm, save, saving } = useUnsubscribeReasonDialog(props);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown
      disableBackdropClose
      disableScrollLock
    >
      <DialogTitle
        onClose={onClose}
        subtitle="Please provide a reason for unsubscribing this customer."
      >
        Unsubscribe {customer?.email}
      </DialogTitle>
      <DialogContent>
        <Form form={form} onSubmit={submitForm}>
          <Grid container spacing={6} verticalSpacing={1}>
            <Grid item xs={12} md={12}>
              <TextControl
                name="statusReason"
                defaultValue=""
                label="Reason for Unsubscribing"
                showHelperTextMargin
                required
                multiline
                rows={1}
                maxLength={50}
                placeholder="Please provide a reason..."
              />
            </Grid>
          </Grid>
          <Divider mt={6} />
          <button type="submit" hidden />
        </Form>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          loading={saving}
          disabled={saving}
          onClick={save}
        >
          Unsubscribe
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UnsubscribeReasonDialog;
